import React, { Component } from 'react';
import Dropdown from '../common/Dropdown';
import Search from '../common/Search';
import { OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import { map, truncate } from 'lodash';
import NotificationView from '../common/NotificationView';
import EmergencyDropdownView from '../common/EmergencyDropdownView';
import io from 'socket.io-client';
import { BASE_URL } from '../../constants/api';
import ToastMessage from '../common/ToastMessage';
import MessagesDropdownView from '../common/MessagesDropdownView';
import { imageBasePath, appBasePath, metaTagData, canonicalLink } from '../../constants/staticData';
import { Helmet } from "react-helmet";


export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      autoAcceptJobSwitch: false,
      messageSelected: false,
      toolTipText: 'Customize your quotes and send them without even logging in.'
    };
    this.windowWidth = this.windowWidth.bind(this);
  }
  componentWillMount() {
    if (!this.props.authReducer.loadedAccountStatus) {
      this.props.actions.getAccountStatus();
    }
    this.props.actions.getJobSchedule();
    if (localStorage.businessAccessToken && !window.socket) {
      window.socket = io.connect(BASE_URL, { query: 'token=' + localStorage.businessAccessToken, reconnection: true, reconnectionDelay: 1000, reconnectionDelayMax: 5000, reconnectionAttempts: 99999 });
      const that = this;
      window.socket.on('Job Accepted', function (data) {
        console.log('Job Accepted', data);
        that.props.actions.getEmergencyList();
        that.props.actions.newSocketNotification(data, 'Job Accepted');
        data && that.props.actions.increaseOpenJobs('jobAccepted', data);
        data && that.props.actions.updateJobOverview(data, 'confirmed');
        that.props.actions.getJobSchedule();
      });
      window.socket.on('New Request', function (data) {
        console.log('New Request', data);
        that.props.actions.getEmergencyList();
        // data && that.props.actions.increaseOpenJobs("newrequest",data);
        that.props.actions.newSocketNotification(data, 'New Request');
        // that.props.actions.updateJobOverview(data, 'waiting');
      });
      window.socket.on('Job Loss', function (data) {
        console.log("Job Loss data = ", data);
        data.data.msg = data.msg;
        that.props.actions.newSocketNotification(data.data, 'Job Loss');
      });
      window.socket.on('Job For The Day', function (data) {
        data.data.msg = data.msg;
        that.props.actions.newSocketNotification(data.data, 'Job For The Day');
      });
      window.socket.on('job-message', function (data) {
        console.log('Received job-message: ', data);
        that.props.actions.receiveNewMessage(data, data.msg.job_chatroom_id);
      });
      window.socket.on('Payment Status', function (data) {
        console.log('Received Payment Status: ', data);
        data.data.msg = data.msg;
        that.props.actions.newSocketNotification(data.data, 'Request Edit');
      });

      window.socket.on('Pay At Shop', function (data) {
        console.log('Received pay at shop Status: ', data);
        data.data.msg = data.msg;
        that.props.actions.newSocketNotification(data.data, 'Request Edit');
      });

      window.socket.on('Auto Quote', function (data) {
        if(data.data.bookingId.substring(0,3) === 'EMG') {
          console.log("EMG Auto Quote data = ", data);
          that.props.actions.getEmergencyList();
          data.data.msg = data.msg;
          that.props.actions.newSocketNotification(data.data, 'Auto Quote');
          // that.props.actions.updateJobOverview(data, 'applied');
        }
      });
      window.socket.on('Request Edit', function (data) {
        data.data.msg = data.msg;
        that.props.actions.newSocketNotification(data.data, 'Request Edit');
      });
      window.socket.on('Request Cancel', function (data) {
        console.log("Request Cancel data = ", data);
        data.data.msg = data.msg;
        that.props.actions.newSocketNotification(data.data, 'Request Cancel');

      });
      window.socket.on('Confirmed Job Decline', function (data) {
        console.log("Confirmed Job Decline data = ", data);
        data.data.msg = data.msg;
        that.props.actions.newSocketNotification(data.data, 'Confirmed Job Decline');

      });
      window.socket.on('Request Expired', function (data) {
        console.log("Request Expired data = ", data);
        data.data.msg = data.msg;
        that.props.actions.newSocketNotification(data.data, 'Request Expired');
      });

      window.socket.on('Emergency Accepted', function (data) {
        console.log("Emergency Accepted data = ", data);
      });

      window.socket.on('Emergency Declined', function (data) {
        console.log("Emergency Declined data = ", data);
      });

      window.socket.on('New Review', function (data) {
        that.props.actions.newSocketNotification({ msg: data.msg }, 'New Review');
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.authReducer && nextProps.authReducer.authData) {
      if (this.state.autoAcceptJobSwitch != nextProps.authReducer.authData.autoacceptjob) {
        this.setState({ autoAcceptJobSwitch: nextProps.authReducer.authData.autoacceptjob });
      }
    }
  }
  windowWidth() {
    let docElemProp = window.document.documentElement.clientWidth, body = window.document.body;
    return (window.document.compatMode === 'CSS1Compat' && docElemProp) || (body && body.clientWidth) || docElemProp;
  }
  Sidebaractivate() {
    this.state.selectedState == true;
  }
  render() {
    const { actions, router, commonReducer, authReducer, metaTagKey } = this.props;
    const windowWidth = this.windowWidth();
    return (
      <div>
        {metaTagData ? <Helmet>
          <meta charSet="utf-8" />
          <title>{metaTagData[metaTagKey] && metaTagData[metaTagKey].title ? metaTagData[metaTagKey].title : 'Carcility Business'}</title>
          <meta name="description" content={metaTagData[metaTagKey] && metaTagData[metaTagKey].description ? metaTagData[metaTagKey].description : ''} />
          <link rel="canonical" href={window.location.href} />
          <link rel="canonical" href={canonicalLink} />
        </Helmet> : ''}
        <div
          className={
            this.props.customClass
              ? `header-section navbar-fixed-top ${this.props.customClass}`
              : 'header-section navbar-fixed-top'
          }
        >
          {!this.props.isNewUser &&
            <div className="menu-option mobileshow" onClick={this.props.hCallback}>
              <label><i className="mdi mdi-menu" /></label>
            </div>}
          <div className="logo-section page-logo-section">
            <a
              onClick={e => {
                e.preventDefault();
                this.props.router.push(`${appBasePath}/overview`);
              }}
            >
              <img src={`${imageBasePath}/logo.svg`} alt="" className="logo-img" />
            </a>
          </div>
          {!this.props.isNewUser && !this.props.searchMobile && <div className="header-search">
            <Search actions={this.props.actions} noAutoSuggestCall={this.props.noAutoSuggestCall} commonReducer={this.props.commonReducer} />
          </div>}
          {!this.props.isNewUser && <div className="toggleBtn mobilehide">
            <ToggleSwitch
              checked={this.state.autoAcceptJobSwitch}
              onChange={() => {
                actions.autoAcceptJob(!this.state.autoAcceptJobSwitch);
                this.setState({ autoAcceptJobSwitch: !this.state.autoAcceptJobSwitch });
              }}
              size="small"
              ref={(node) => {
                this.toggleSwitch = node;
              }} />
            {/*<label>{this.state.autoAcceptJobSwitch ? "Auto Job: On" : "Auto Job: Off"}</label>*/}
            <label>Auto Job</label>
            <span>
              <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Popover positionLeft={100} id="header-dropdown"> {this.state.toolTipText.length < 50 ? this.state.toolTipText : truncate(this.state.toolTipText, { 'length': 80, 'separator': ' ' })}</Popover>}>
                <i className="mdi mdi-information-outline" />
              </OverlayTrigger>
            </span>
          </div>}
          <div className="header-right">
            {/* Verify and Version label*/}
            {authReducer && authReducer.authData && authReducer.authData.businessstatusname ? <span className={authReducer.authData.businessstatus === 2 ? "version-label" : "version-label not-verified"} > {authReducer.authData.businessstatusname} </span> : ''}
            <ul className="list-unstyled header-menu-icons">
              <li className="search-mobile" onClick={this.props.hideOption}>
                {!this.props.isNewUser && <i className="mdi mdi-magnify" aria-hidden="true" />}
              </li>
              <EmergencyDropdownView
                {...this.props}
                emergencyClick={() => {
                  if (windowWidth <= 991) {
                    this.props.router.push(`${appBasePath}/emergency-list`);
                  }
                }}
              />
              <NotificationView
                notiClick={() => {
                  if (windowWidth <= 991) {
                    this.props.router.push(`${appBasePath}/notification`);
                  }
                }}
                commonReducer={commonReducer}
                actions={actions}
                router={router}
              />
              {!this.props.isNewUser &&
                <MessagesDropdownView
                  {...this.props}
                  msgClick={() => {
                    if (windowWidth <= 991) {
                      this.props.router.push(`${appBasePath}/inbox`);
                    }
                  }}
                />}
              <li className="profile-header">
                <Dropdown actions={actions} router={router} commonReducer={commonReducer} />
              </li>
            </ul>
          </div>
        </div>

        {commonReducer.toastMessage &&
          <ToastMessage
            actions={actions}
            type={commonReducer.toastType}
            title={commonReducer.toastType + '...'}
            text={commonReducer.toastMessage}
          />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Header.jsx